"use strict";

class SSKeyHandoverService {

    constructor($timeout, SSConfigService, SSHttpService, SSAwsService, SSUtilService, SSUserService, SSAlertService, SSConfirmationService, SSDateService, SSKeyHandoverScheduleService, NgTableParams) {
        const self = this;

        self.SSConfigService = SSConfigService;
        self.SSHttpService = SSHttpService;
        self.SSAwsService = SSAwsService;
        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSDateService = SSDateService;
        self.NgTableParams = NgTableParams;
        self.SSKeyHandoverScheduleService = SSKeyHandoverScheduleService;

        self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED = 10;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_PENDING = 13;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_SUCCESSFUL = 20;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED = 30;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED = 40;

        self.KEY_HANDOVER_BUYER_TYPE_MAIN = 10;
        self.KEY_HANDOVER_BUYER_TYPE_NOMINEE = 20;

        self.APPOINTMENT_FILE_TYPE_LETTER_OF_AUTHORISATION = 10;

        self.IDENTITY_TYPE_SINGAPOREAN = 'singaporean';
        self.IDENTITY_TYPE_SINGAPORE_PR = 'singaporean_pr';
        self.IDENTITY_TYPE_FOREIGNER = 'foreigner';

        self.$timeout = $timeout;

        self.users = [];
        self.buyers = [];
        self.agencies = [];

        self.APPOINTMENTS_DATA = {};
        // self.updateStatusParams={};
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
        self.APPOINTMENT_FILE_TYPE_OTHERS = SHOWSUITE.APPOINTMENT_FILE_TYPE_OTHERS;

        self.init();
    }

    init() {
        const self = this;

        self.STEP_NUMBER = 0;
        self.SHOW_STEP = {1: false, 2: false, 3: false};
        // Default 'max_appointment_days' 
        self.max_appointment_days = 30;

        self.limit = 10;
        self.current = 1;

        self.initStatuses();
        self.prepareConstants();

        self.pageChanged = function(newPage) {
            self.getKeyHandoverAppointments(self.searchFilter, newPage);
        };

        self.$timeout(function() { $("select.dashboard-select#property-select").niceSelect('update'); });
    }

    prepareConstants(){
        const self = this;

        self.BUYER_TYPES = [
            {id: self.KEY_HANDOVER_BUYER_TYPE_MAIN, name: 'Main'},
            {id: self.KEY_HANDOVER_BUYER_TYPE_NOMINEE, name: 'Nominee'}
        ];

        self.IDENTITY_TYPES = [
            {id: self.IDENTITY_TYPE_SINGAPOREAN, name: 'Singaporean'},
            {id: self.IDENTITY_TYPE_SINGAPORE_PR, name: 'Singapore PR'},
            {id: self.IDENTITY_TYPE_FOREIGNER, name: 'Foreigner'}
        ];
    }

    getPropertySettings(url, callback) {
        const self = this;
 
        if(!url){
            console.log('Invalid url to get property settings.');
            return;
        }

        // WEB-4818: kept so a refused booking can reload the settings it was checked against
        self.propertySettingsUrl = url;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.property_settings){

                // Get Key Handover Settings
                self.key_handover_settings = self.getSetting(response.data.property_settings, 'key_handover_settings');
            
                if(self.key_handover_settings){
                    /**
                     * WEB-4818: slot times stay in stored UTC here and are converted per date, in
                     * the project's timezone rather than the browser's, when the slots are built
                     * (SSKeyHandoverScheduleService.buildSlots()). Appointment times use the same zone.
                     */
                    self.timeZoneId = self.SSKeyHandoverScheduleService.timeZoneId(self.key_handover_settings.value);

                    self.max_appointment_days = self.key_handover_settings.value.max_appointment_days? parseInt(self.key_handover_settings.value.max_appointment_days)+5 : 1;
                    // All appointments to exclude the booked one for new appointment
                    self.getAllAppointments(self.max_appointment_days);
                }
            }

            callback({success: true, key_handover_settings: self.key_handover_settings});
        });
    }

    clearSearchFilters(){
        const self = this;

        self.start_date = null;
        self.search_text = "";

        self.getKeyHandoverAppointments(self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED);
    }

    getAllAppointments(max_appointment_days, showLoading = true){
        const self = this;

        if(!max_appointment_days){
            max_appointment_days = self.max_appointment_days;
        }

        /**
         * WEB-4818: the days are the project's, and the server filters in UTC, so widen the
         * window by a day each side rather than miss bookings near midnight.
         */
        let today = self.SSKeyHandoverScheduleService.nowInProject(self.timeZoneId);
        let startDate = today.clone().subtract(1, 'days');
        let endDate = today.clone().add(max_appointment_days + 1, 'days');

        let url = 'sec/developer/key-handover/appointments';
        let statuses = [self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED, self.KEY_HANDOVER_APPOINTMENT_STATUS_PENDING].join();
        
        let params = {
            property_id: self.property? self.property.id : null,
            response_type: 1,
            status: statuses,
            start_date: startDate.format('YYYY-MM-DD') + " 00:00",
            end_date: endDate.format('YYYY-MM-DD') + " 00:00",
            include: 'documents, all_documents'
        };

        loading(showLoading);
        this.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.success && response.data) {
                self.APPOINTMENTS_DATA = {};
                self.allAppointments = self.getFormattedAppointments(response.data.key_handover_appointments, true);
                self.prepareData();
            }
        });
    }

    getKeyHandoverAppointments(status, page = 1){
        const self = this;

        self.offset = (page * self.limit) - self.limit;
        if(page) {
            self.current = page;
        }

        // WEB-4411: the filter's datepicker writes dd/mm/yy; parse it explicitly (moment's
        // format-less fallback reads 07/09/2026 as 9 July and rejects 23/09/2026).
        let searchDate = self.start_date? moment(self.start_date, 'DD/MM/YYYY'): null;
        let startDate = searchDate? searchDate.format('YYYY-MM-DD HH:mm:ss') : null;
        let endDate = searchDate? searchDate.add(24, 'hours').format('YYYY-MM-DD HH:mm:ss') : null;

        let url = 'sec/developer/key-handover/appointments';
        let params = {
            property_id: self.property? self.property.id : null,
            response_type: 1,
            include: 'buyers, units, documents, primary_address, all_documents',
            limit: self.limit,
            offset: self.offset,
            send_total_count: 1,
            status: status?status:self.searchFilter,
            search_text: self.search_text,
            start_date: startDate,
            end_date: endDate
        };

        loading(true);
        this.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.success && response.data) {
                self.buyers = response.data.buyers;
                self.users = response.data.users;

                self.appointments = self.getFormattedAppointments(response.data.key_handover_appointments);
                self.appointmentStats = response.data.appointment_stats;

                // self.prepareData();

                self.count = response.data.total_count;
                self.total_count = response.data.total_count;
                self.pages = Math.ceil(self.count / self.limit);
                self.selectedPage = Math.floor(self.offset / self.limit) + 1;
                self.pagesArr = [];

                for (var i = 0; i < self.pages; i++) {
                    self.pagesArr.push(i);
                }
            }
            
            // callback({appointments: self.appointments, total_count: total_count, APPOINTMENTS_DATA: self.APPOINTMENTS_DATA});
        });
    }

    getFilteredAppointments(status){
        const self = this;

        self.searchFilter = status;
        // self.start_date = '';
        self.end_date = '';

        self.offset = 0;
        self.selectedPage = 1;
        self.getKeyHandoverAppointments(status);
    }

    getFormattedAppointments(appointments, initAppointmentRecords = false){
        const self = this;

        if(!appointments){
            return null;
        }

        $.each(appointments, function(index, appointment){

            appointment.start_date = self.formatUtcToLocalDate(appointment.start_date);
            appointment.end_date = self.formatUtcToLocalDate(appointment.end_date);

            if(appointment.status == self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED 
                && (self.searchFilter == '' || self.searchFilter == self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED)
                && moment(appointment.end_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm') < self.SSKeyHandoverScheduleService.nowInProject(self.timeZoneId).format('YYYY-MM-DD HH:mm')){
                appointment.status = self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED;
            }

            var status = self.getStatus(appointment.status);

            appointment.status_name = status.name;
            appointment.status_class = status._class;

            appointment.created_by_user = self.getUserName(appointment.created_by);

            try{
                // Process buyers
                if(!appointment.hasOwnProperty("buyers")){
                    appointment["buyers"] = [];
                }
                $.each(appointment.buyer_ids, function(idx, buyer_id){
                    let buyer = self.buyers.find(x => x.id == buyer_id);
                    if(buyer){
                        buyer.legal_name = self.getBuyerName(buyer_id, self.buyers);
                        if(buyer.type == self.KEY_HANDOVER_BUYER_TYPE_NOMINEE){

                            self.getPresignedUrl(appointment.id, buyer, 'authorisation_letter_uri', function (presignedUrl) {
                                buyer.show_authorisation_letter_uri = presignedUrl;
                            });
                            
                            if(buyer.identity_type == self.IDENTITY_TYPE_FOREIGNER){
                                // Passport image is saved as 'nric_front' in case of 'foreigner'
                                self.getPresignedUrl(appointment.id, buyer, 'nric_front_uri', function (presignedUrl) {
                                    buyer.show_nric_front_uri = presignedUrl;
                                });
                            }
                            else{
                                self.getPresignedUrl(appointment.id, buyer, 'nric_front_uri', function (presignedUrl) {
                                    buyer.show_nric_front_uri = presignedUrl;
                                });
                                self.getPresignedUrl(appointment.id, buyer, 'nric_back_uri', function (presignedUrl) {
                                    buyer.show_nric_back_uri = presignedUrl;
                                });
                            }
                        }
                        appointment.buyers.push(buyer);
                    }
                });
                // Re-arrange buyers by type e.g type: 10 first then type: 20
                appointment.buyers = _.sortBy(appointment.buyers, 'type');
            }
            catch(ex){
                console.log(ex);
            }

            // Prepare data for associative array to enable/disable slots
            var date = moment(appointment.start_date).format('YYYY-MM-DD');
            var time = moment(appointment.start_date).format('HH:mm:ss')+ '-' +moment(appointment.end_date).format('HH:mm:ss');
            appointment.date = date;
            appointment.time = time;

            if(initAppointmentRecords){
                self.updateAppointmentsRecord(date, time);
            }
        });

        return appointments;
    }

    /**
     * Build the day list of the booking wizard (step 1).
     *
     * @remarks
     * WEB-4818: each date resolves special day → weekday → General (SSKeyHandoverScheduleService),
     * on the project's clock. An Off special day closes the date; an On one can open a Closed
     * weekday. A day whose PENDING + SCHEDULED bookings reach its Max Unit(s) Per Day is full.
     */
    prepareData(){
        const self = this;

        self.available_days = [];

        let value = self.key_handover_settings.value;

        let max_appointment_days = value.max_appointment_days;
        max_appointment_days = max_appointment_days? parseInt(max_appointment_days) : 7;

        if(value.slots_enabled_after_days)
            max_appointment_days += parseInt(value.slots_enabled_after_days);

        // Number of tables
        self.tables = [];

        let number_of_tables = value.number_of_tables;
        number_of_tables = number_of_tables? parseInt(number_of_tables) : 1;

        for(var index = 1; index <= number_of_tables; index++){
            self.tables.push({id: index.toString(), name: "SLOT " + index});
        }

        // "Today" is the project's today
        let today = self.SSKeyHandoverScheduleService.nowInProject(self.timeZoneId).startOf('day');

        for(var index = 0; index < max_appointment_days; index++){

            let date = today.clone().add(index, 'days');
            let dateValue = date.format('YYYY-MM-DD');

            let slot_times = self.getSlotTimes(date);

            // Units per slot are read against each slot's own date — the next day for a slot after midnight
            let total_slots = 0;
            let capacity = 0;
            $.each(slot_times, function(i, slot){
                let slotCapacity = self.getSlotCapacityForDate(slot.date);
                capacity += slotCapacity;
                if(!slot.is_expired) total_slots += slotCapacity;
            });

            let booked = self.getBookedCountForDate(dateValue);
            let available = Math.max(0, total_slots - booked);

            // Max Unit(s) Per Day caps what is left, and a day at its limit is full however many slots are empty
            let maxPerDay = self.getMaxUnitsPerDayForDate(date);
            if(maxPerDay !== null){
                available = Math.min(available, Math.max(0, maxPerDay - booked));
            }

            self.available_days.push({
                id: index+1,
                closed: slot_times.length == 0 || capacity == 0,
                is_full: self.isDayFull(dateValue),
                name: date.format('dddd, Do MMMM YYYY'),
                value: dateValue,
                all_slots: slot_times,
                available_slots_count: available
            });
        }

        // Keep an open slot list current when the bookings or settings are reloaded
        if(self.SHOW_STEP[2] && self.selected_date && self.selected_date.value){
            self.slot_times = self.getSlotTimes(self.selected_date);
        }
    }

    updateAppointmentsRecord(date, time){
        const self = this;

        if(self.APPOINTMENTS_DATA[date]){
            self.APPOINTMENTS_DATA[date] = self.APPOINTMENTS_DATA[date] + 1;
        }
        else{
            self.APPOINTMENTS_DATA[date] = 1;
        }

        if(self.APPOINTMENTS_DATA[date + '-' + time]){
            self.APPOINTMENTS_DATA[date + '-' + time] = self.APPOINTMENTS_DATA[date + '-' + time] + 1;
        }
        else{
            self.APPOINTMENTS_DATA[date + '-' + time] = 1;
        }

    }

    addNewDocument(params){
        const self = this;

        if(!params.buyer_documents)
            params.buyer_documents = [];

        params.buyer_documents.push({});
    }

    removeDocument(index, params){
        const self = this;

        if(params.buyer_documents.length == 1){
            params.buyer_documents[index] = {};
            return;
        }

        let documents = [];
        
        delete params.buyer_documents[index];
        $.each(params.buyer_documents, function(i, document){
            if(document)
                documents.push(document);
        });

        params.buyer_documents = documents;
    }

    addNewBuyer(){
        const self = this;

        // User can not add more than 6 buyers
        let newBuyer = {type: self.KEY_HANDOVER_BUYER_TYPE_MAIN, phone_contact: "+65"};

        if(self.appointmentParams.buyers.length >= 6){
            // Can't add more than 6 buyers
            // self.appointmentErrors.buyers = "Can not add more than 6 buyers.";
            self.SSAlertService.danger("Can not add more than 6 buyers.");
            return;
        }
        
        self.appointmentParams.buyers.push(newBuyer);

        // Update phone input
        setTimeout(function(){
            let index = self.appointmentParams.buyers.length-1;
            if($("#phone_"+index).length)
                self.SSUserService.maskPhoneNumber(self, 'ctrl.SSKeyHandoverService.', 'phone_'+index);
        });
    }

    removeBuyer(index){
        const self = this;

        self.appointmentParams.buyers.splice(index, 1);
    }

    addRepresentative(buyer){
        const self = this;

        if(!buyer) return;

        let representative = {type: self.KEY_HANDOVER_BUYER_TYPE_NOMINEE, phone_contact: "+65"};
        representative.buyer_documents = [{}];
        
        buyer.authorised_representative = representative;

        // Update phone input
        setTimeout(function(){
            let index = self.appointmentParams.buyers.length-1;
            if($("#phone_"+(index+1)).length)
                self.SSUserService.maskPhoneNumber(self, 'ctrl.SSKeyHandoverService.', 'phone_'+(index+1));
        });
    }

    removeRepresentative(buyer){
        const self = this;

        if(!buyer) return;

        delete buyer.authorised_representative;
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){
            return null;
        }

        let setting = {};

        try{
            setting = settings.find(x => x.name == setting_name);

            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                }
                else{
                    setting.value = setting.value;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return setting;
    }

    /**
     * The slots of one date (step 2).
     *
     * @remarks
     * WEB-4818: the date's resolved Start/End ranges split by its resolved duration (special day →
     * weekday → General), in the project's timezone. A range running past midnight keeps its
     * after-midnight slots in this list, but each slot carries its own `date` (and `end_date`),
     * which is the date it is booked and counted on.
     *
     * @param {moment|string|Object} date - A moment, a `YYYY-MM-DD` string or an available_days entry.
     * @returns {Array} The slots, empty for a closed date.
     */
    getSlotTimes(date){
        const self = this;

        if(!self.key_handover_settings || !self.key_handover_settings.value) return [];

        if(typeof date == 'object' && !moment.isMoment(date))
            date = moment(date.value, 'YYYY-MM-DD');
        else if(typeof date == 'string')
            date = moment(date, 'YYYY-MM-DD');

        if(!date || !date.isValid()) return [];

        let listDate = date.format('YYYY-MM-DD');
        let now = self.SSKeyHandoverScheduleService.nowInProject(self.timeZoneId);
        let raw = self.SSKeyHandoverScheduleService.buildSlots(self.key_handover_settings.value, listDate, self.timeZoneId);

        return raw.map(function(range){
            let slot_info = {
                id: range.range_index,
                date: range.start.format('YYYY-MM-DD'),
                end_date: range.end.format('YYYY-MM-DD'),
                start_time: range.start.format('HH:mm:ss'),
                end_time: range.end.format('HH:mm:ss'),
                name: range.start.format('hh:mm A')
                    + (range.start.format('YYYY-MM-DD') != listDate? ' (next day)' : '')
            };

            slot_info.is_expired = range.start.isBefore(now);
            slot_info.is_booked = self.isBookedSlot(slot_info.date, slot_info.start_time, slot_info.end_time);
            slot_info.is_day_full = self.isDayFull(slot_info.date);

            return slot_info;
        });
    }

    getAllSlots(date){
        const self = this;

        if(!date) return;

        return self.getSlotTimes(date);
    }

    /**
     * Whether `appointment` is the one being edited. It never counts against its own slot or
     * day, or moving it within a full day would be refused by its own booking.
     */
    isEditingAppointment(appointment){
        const self = this;

        return !!(appointment && self.appointmentParams && self.appointmentParams.id
            && appointment.id == self.appointmentParams.id);
    }

    /**
     * WEB-4818: PENDING + SCHEDULED appointments starting on `date` — the count the server
     * checks Max Unit(s) Per Day against.
     *
     * @param {string} date - `YYYY-MM-DD` on the project's clock.
     */
    getBookedCountForDate(date){
        const self = this;

        return (self.allAppointments || []).filter(x => x.date == date && !self.isEditingAppointment(x)).length;
    }

    /**
     * WEB-4818: Max Unit(s) Per Day for `date` — special day, then weekday, then General — or
     * null for no limit.
     */
    getMaxUnitsPerDayForDate(date){
        const self = this;

        if(!self.key_handover_settings || !self.key_handover_settings.value) return null;

        return self.SSKeyHandoverScheduleService.resolveDay(self.key_handover_settings.value, moment(date, 'YYYY-MM-DD')).max_units_per_day;
    }

    /**
     * WEB-4818: Whether `date` has reached its Max Unit(s) Per Day.
     */
    isDayFull(date){
        const self = this;

        let maxPerDay = self.getMaxUnitsPerDayForDate(date);

        return maxPerDay !== null && self.getBookedCountForDate(date) >= maxPerDay;
    }

    /**
     * Effective slot capacity (No. of Unit(s) Per Slot) for one booking date.
     *
     * @remarks
     * WEB-4818: special day → weekday → General, as the server resolves it. Keeping the grid on the
     * same rule matters: otherwise a reduced day still advertises the full slot count here and the
     * save is refused with 412038.
     *
     * @param {moment|string} date - Booking date, as a moment or a YYYY-MM-DD string.
     * @returns {number} The capacity for that date (1 when nothing is configured).
     */
    getSlotCapacityForDate(date){
        const self = this;

        let value = self.key_handover_settings? self.key_handover_settings.value : null;
        if(!value || !date) return 1;

        let day = typeof date == 'string'? moment(date, 'YYYY-MM-DD') : date;
        if(!day || !day.isValid()) return 1;

        let tables = self.SSKeyHandoverScheduleService.resolveDay(value, day).number_of_tables;

        return tables === null? 1 : tables;
    }

    isExpiredSlot(date, start_time, end_time){
        const self = this;

        if(!date || !start_time || !end_time){
            return false;
        }

        let start = moment(date + ' ' + start_time, 'YYYY-MM-DD HH:mm:ss');

        return start.isBefore(self.SSKeyHandoverScheduleService.nowInProject(self.timeZoneId));
    }

    isBookedSlot(date, start_time, end_time){
        const self = this;

        if(!date || !start_time || !end_time){
            return false;
        }

        let time = start_time + '-' + end_time;
        let bookedSlots = (self.allAppointments || [])
            .filter(x => x.date == date && x.time == time && !self.isEditingAppointment(x)).length;

        return bookedSlots >= self.getSlotCapacityForDate(date);
    }

    getSlotStatus(slot){
        const self = this;

        // Slot Status -> 'Booked', 'Day Full', 'Expired'
        if(slot.is_booked) return 'Booked';
        if(slot.is_day_full) return 'Day Full';
        if(slot.is_expired) return 'Expired';

        return 'Available';
    }

    /**
     * Whether `slot` is the time of the appointment being edited, which is highlighted.
     */
    isCurrentAppointmentSlot(slot){
        const self = this;

        return !!(self.appointmentParams
            && self.appointmentParams.date == slot.date
            && self.appointmentParams.time == slot.start_time+'-'+slot.end_time);
    }

    getSlotClass(slot){
        const self = this;

        if(slot.is_expired){
            return 'disabled btn-outline-danger';
        }

        if(self.isCurrentAppointmentSlot(slot)
            && self.appointmentParams.status != self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED
            && self.appointmentParams.status != self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED){
            // It will highlight the time of current selected slot
            return 'highlight';
        }

        if(slot.is_booked || slot.is_day_full){
            return 'disabled btn-outline-danger';
        }

        return '';
    }

    getBookedSlotClass(slot){
        const self = this;

        let cls = '';

        if(slot.is_expired){
            return 'disabled';
        }

        if(self.isCurrentAppointmentSlot(slot)
            && self.appointmentParams.status != self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED){
            // It will highlight the time of current selected slot
            cls = 'highlight';
        }
        if(slot.is_booked || slot.is_day_full){
            cls += ' text-warning';
        }

        return cls;
    }

    saveUserAppointment(status) {
        const self = this;

        self.update_appointment_status = status;

        if(!self.isValidAppointmentInput()) return;
        self.appointmentErrors = {};

        self.confirmationMessage = 'Are you sure you want to proceed to update the appointment changes?';
        if (self.appointmentParams.status == self.KEY_HANDOVER_APPOINTMENT_STATUS_PENDING
            && status == self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED
        ) {
            self.confirmationMessage = 'Are you sure you want to update and approve this appointment? If you proceed, the changes will be updated and also the appointment will be placed under Scheduled section.';
        } else if (self.appointmentParams.status == self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED
            || self.appointmentParams.status == self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED
        ) {
            self.confirmationMessage = 'Are you sure you want to update the appointment? If you proceed the changes will be updated. And also the appointment will be placed under Scheduled section.';
        }

        $('#keyhandoverAppointmentConfirmationModal').modal('show');
    }

    _saveUserAppointment() {
        const self = this;

        let url = 'sec/developer/key-handover/appointments';
        let params = self.getAppointmentParams();

        params.reschedule = self.reschedule;

        if (self.newAppointment) {
            let unitForNewAppointment = self.SSUtilService.getFromLocalStorage('unitForNewAppointment');
            if (unitForNewAppointment) {
                params.unit_id = unitForNewAppointment.id;
            }
        }

        // 'status' should be updated to SCHEDULED for CANCELED and EXPIRED cases
        if (params.status === self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED
            || params.status === self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED
        ) {
            params.status = self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED;
        } else if (params.status === self.KEY_HANDOVER_APPOINTMENT_STATUS_PENDING) {
            if (self.update_appointment_status) {
                params.status = self.update_appointment_status;
            }
        }

        /** WEB-2798 Keyhandover Collection App: Appointment Address Support **/
        if(params.primary_address){
            params.primary_address_line1 = params.primary_address.line1;
            params.primary_address_line2 = params.primary_address.line2 != null ? params.primary_address.line2 : '';
            params.primary_address_country = params.primary_address.country;
            params.primary_address_city = params.primary_address.city != null ? params.primary_address.city : '';
            params.primary_address_unit_no = params.primary_address.unit_no != null ? params.primary_address.unit_no : '';
            params.primary_address_district = params.primary_address.district != null ? params.primary_address.district : '';
            params.primary_address_postcode = params.primary_address.postcode;
            params.primary_address_residence_type = params.primary_address.residence_type ? params.primary_address.residence_type : null;

        }

        let responseHandler = function (response) {
            loading(false);
            $('#keyhandoverAppointmentConfirmationModal').modal('hide');

            if (response instanceof Error) {
                if (self.recoverFromBookingRejection(response)) return;

                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Key handover appointment updated successfully.');

            self.APPOINTMENT_VIEW_MODE = false;
            self.appointmentEditMode = false;
            self.newAppointment = false;

            self.SSUtilService.deleteFromLocalStorage('newAppointment');
            self.SSUtilService.deleteFromLocalStorage('unitForNewAppointment');

            self.getKeyHandoverAppointments(self.searchFilter);
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    /**
     * WEB-4818: Answer a booking the server refused because what this page showed is out of
     * date — someone else booked (412038 slot full, 412039 day full) or the settings changed
     * (412036 date not bookable, 412037 not a slot of that day).
     *
     * Shows the server's own message, reloads what changed and sends the user back to pick
     * again, with everything they typed kept.
     *
     * @param {Error} response - The rejected response.
     * @returns {boolean} True when it was one of these rejections and has been handled.
     */
    recoverFromBookingRejection(response){
        const self = this;

        let subCode = response? parseInt(response.sub_code) : null;
        let SLOT_REJECTIONS = [412037, 412038];
        let DAY_REJECTIONS = [412036, 412039];

        if (SLOT_REJECTIONS.indexOf(subCode) < 0 && DAY_REJECTIONS.indexOf(subCode) < 0) return false;

        self.SSAlertService.parseAndDisplayServerError(response);

        // Back to the slot list, or to the day list when the whole day is gone
        self.toggleStepsView(SLOT_REJECTIONS.indexOf(subCode) >= 0 && self.selected_date && self.selected_date.value? 2 : 1);

        // A settings change (412036/412037) needs the settings too; that reload also reloads the bookings
        if ((subCode == 412036 || subCode == 412037) && self.propertySettingsUrl) {
            self.getPropertySettings(self.propertySettingsUrl, function(){});
        } else {
            self.getAllAppointments(null);
        }

        return true;
    }

    getAppointmentParams(){
        const self = this;

        let params = angular.copy(self.appointmentParams);

        if(params.buyers){
            params.buyer_ids = [];
            $.each(params.buyers, function(index, buyer){
                params.buyer_ids.push(buyer.id);
            });

            params.buyer_ids = params.buyer_ids? params.buyer_ids.toString() : null;
        }

        params.start_date = self.getParamsDate(params.start_date);
        params.end_date = self.getParamsDate(params.end_date);

        params.buyers = JSON.stringify(params.buyers); 
        
        return params;
    }

    isValidAppointmentInput(){
        const self = this;

        let isValid = true;
        self.appointmentErrors = {};

        if(!self.appointmentParams.buyers || self.appointmentParams.buyers.length == 0
            || !self.appointmentParams.buyers.find(x => x.type == self.KEY_HANDOVER_BUYER_TYPE_MAIN)){
            self.appointmentErrors.buyers = "Please add at least one buyer.";
            isValid = false;
        }

        /**
         * WEB-4304: No. of Pax is optional on the staff side, but the BE range-checks it
         * (1-99) — catch it here so the user gets a field-level message instead of a 412.
         */
        if(self.appointmentParams.no_of_pax){
            let noOfPax = Number(self.appointmentParams.no_of_pax);

            if(isNaN(noOfPax) || noOfPax % 1 !== 0 || noOfPax < 1 || noOfPax > 99){
                self.appointmentErrors.no_of_pax = "Please enter a number between 1 and 99.";
                isValid = false;
            }
        }

        if(!self.isValidBuyerInput()) return false;

        return isValid;
    }

    deleteAppointment(appointment){
        const self = this;

        if(!appointment){
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this appointment? The appointment will be deleted along with all of purchasers details and uploaded documents.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                
                let url = 'sec/developer/key-handover/appointments/'+ appointment.id +'/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    if(response.success){
                        self.SSAlertService.success('Appointment deleted successfully.');
                        self.appointments = $.grep(self.appointments, function(obj){
                            return appointment.id != obj.id;
                        });
                    }
                });

        });
    }

    getPresignedUrl(appointmentId, buyer, document, callback){
        const self = this;

        if(!(document && document.id)) return;

        let url = 'sec/developer/key-handover/appointments/'+ appointmentId +'/presigned-url';
        let params = {
            'buyer_id': buyer? buyer.id : null,
            'document_id': document.id
        };

        //loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            //loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (callback) {
                callback(response.data.presigned_url);
            } else {
                window.open(response.data.presigned_url, '_blank');
            }
        });
    }

    setStepOneViewMode(appointment, step_number = null){
        const self = this;

        self.EDIT_MODE_DISABLED = false;

        if(self.SSUtilService.getFromLocalStorage('newAppointment')){
            self.SSUtilService.deleteFromLocalStorage('newAppointment');
        }

        self.appointmentParams = {};
        self.appointmentErrors = {};

        if(appointment){
            self.newAppointment = false;
            self.appointmentParams = angular.copy(appointment);
        }
        else{
            self.appointmentParams.status = self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED
        }

        self.appointmentParams.property_id = self.property.id;

        self.APPOINTMENT_VIEW_MODE = true;
        self.slot_times = null;

        if(appointment && step_number != 1) {
            self.selected_date = {name: self.formatDate3(appointment.start_date)};
            self.selected_slot = {name: self.SSUtilService.formatUtcToLocalTime(moment(appointment.start_date,'hh:mm a'))};

            step_number = 3;
        }

        if(self.newAppointment){
            self.appointmentEditMode = true;
            self.appointmentParams.unit = self.SSUtilService.getFromLocalStorage('unitForNewAppointment');

            /* WEB-3612: Prefill buyer details from an existing sale against the selected unit (if any). */
            self.prefillBuyersFromSale(self.appointmentParams.unit);
        }

        self.toggleStepsView(step_number);
    }

    /**
     * WEB-3612 — Prefill the appointment buyer list from the buyers of an existing
     * sale against the selected unit.
     *
     * When a Developer creates a Key Handover appointment on behalf of a buyer and a
     * sale already exists against the chosen unit, fetch that sale's buyers and map
     * them onto the appointment buyer form (name, contact, identity). The prefilled
     * data remains fully editable before submission. When no sale exists (or it has
     * no buyers), the buyer list is left untouched so setStepThreeViewMode seeds the
     * default blank buyer — preserving the original behaviour (Scenario 2).
     *
     * @remarks
     * Runs asynchronously while the user is still picking date/time (Steps 1–2), so
     * the buyers are populated before the buyer form (Step 3) is rendered.
     *
     * Edge cases:
     *  - Unit with multiple sales: the units/sale_ids endpoint already resolves a
     *    single sale_id per unit server-side, so we simply use that sale.
     *  - Aborted/cancelled sales: excluded server-side from units/sale_ids.
     *  - Any fetch/parse failure falls back silently to the blank form.
     *
     * @param {Object} unit - Selected unit, carrying sale_id and sale_buyers_count.
     * @returns {void}
     */
    prefillBuyersFromSale(unit){
        const self = this;

        // Only prefill for a brand-new appointment against a unit that has a sale with buyers.
        if(!self.newAppointment || !unit || !unit.sale_id || !unit.sale_buyers_count){
            return;
        }

        let url = 'sec/sales/' + unit.sale_id;
        let params = { include: 'sale_buyers' };

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            // Silent fallback to the blank form rather than blocking appointment creation.
            if (response instanceof Error) {
                console.warn('WEB-3612: Unable to prefill buyers from sale.', response);
                return;
            }

            if (!response || !response.data || !response.data.sales || !response.data.sales.length) {
                return;
            }

            let saleBuyers = response.data.sales[0].sale_buyers || [];

            let prefilledBuyers = [];
            $.each(saleBuyers, function (i, saleBuyer) {
                let data = saleBuyer ? saleBuyer.data : null;

                if (typeof data === 'string') {
                    try {
                        data = JSON.parse(data);
                    } catch (e) {
                        console.warn('WEB-3612: Failed to parse sale buyer data.', e);
                        data = null;
                    }
                }

                let mapped = self.mapSaleBuyerToAppointmentBuyer(data);
                if (mapped) {
                    prefilledBuyers.push(mapped);
                }
            });

            // Respect the buyer form's 6-buyer maximum (see addNewBuyer).
            if (prefilledBuyers.length > 6) {
                prefilledBuyers = prefilledBuyers.slice(0, 6);
            }

            // Only overwrite the (still-empty) buyer list when buyers were actually mapped;
            // otherwise leave it for setStepThreeViewMode to seed a blank buyer.
            if (prefilledBuyers.length) {
                self.appointmentParams.buyers = prefilledBuyers;
            }
        });
    }

    /**
     * WEB-3612 — Map a parsed sale buyer (sale_buyer.data) onto a Key Handover
     * appointment buyer object.
     *
     * The appointment buyer form uses a flat shape (legal_name, email_contact,
     * phone_contact, identity_type, identity_no), whereas a sale buyer stores a
     * nested particulars object. For company buyers the legal name falls back to
     * the company name and identity fields are left blank (not applicable).
     *
     * @param {Object} data - Parsed sale_buyer.data JSON.
     * @returns {Object|null} Appointment buyer object, or null when no usable data.
     */
    mapSaleBuyerToAppointmentBuyer(data){
        const self = this;

        if (!data) {
            return null;
        }

        let individual = data.individual || null;
        let company = data.company || null;

        let legalName = (individual && individual.legal_name)
            ? individual.legal_name
            : (company && company.name ? company.name : null);

        let email = (data.email_contact && data.email_contact.value) ? data.email_contact.value : null;
        let phone = (data.phone1_contact && data.phone1_contact.value) ? data.phone1_contact.value : '+65';

        let identityType = individual ? individual.identity_type : null;
        let identityNo = null;
        if (individual) {
            identityNo = (identityType === self.IDENTITY_TYPE_FOREIGNER)
                ? individual.passport_no
                : individual.national_id;
        }

        return {
            type: self.KEY_HANDOVER_BUYER_TYPE_MAIN,
            legal_name: legalName,
            email_contact: email,
            phone_contact: phone,
            identity_type: identityType,
            identity_no: identityNo,
            vehicle_no: null,
            buyer_documents: []
        };
    }

    setStepTwoViewMode(day, step_number){
        const self = this;

        self.selected_date = day;
        self.slot_times = self.getSlotTimes(day);

        self.toggleStepsView(step_number);
    }

    setStepThreeViewMode(slot, table_no, step_number){
        const self = this;

        self.selected_slot = slot;

        // WEB-4818: the slot's own dates — after midnight they are the next day's
        self.appointmentParams.start_date = (slot.date || self.selected_date.value) + " " + slot.start_time;
        self.appointmentParams.end_date = (slot.end_date || slot.date || self.selected_date.value) + " " + slot.end_time;
        self.appointmentParams.table_no = table_no;

        if(!self.appointmentParams.buyers 
            || (self.appointmentParams.buyers && self.appointmentParams.buyers.length == 0))
            self.appointmentParams.buyers = [{type: self.KEY_HANDOVER_BUYER_TYPE_MAIN}];

        self.updateNiceSelect();
        self.toggleStepsView(step_number);

        setTimeout(function(){
            $.each(self.appointmentParams.buyers, function(i, buyer){
                if($("#phone_"+i).length)
                    self.SSUserService.maskPhoneNumber(self, 'ctrl.SSKeyHandoverService.', 'phone_'+i);
            });
        });
    }

    toggleStepsView(step_number){
        const self = this;

        self.SHOW_STEP[1] = false;
        self.SHOW_STEP[2] = false;
        self.SHOW_STEP[3] = false;

        self.SHOW_STEP[step_number] = true;
        self.STEP_NUMBER = step_number;
    }
    
    goBack(step_number){
        const self = this;

        self.STEP_NUMBER--;

        if(step_number != undefined)
            self.STEP_NUMBER = parseInt(step_number);

        if(self.STEP_NUMBER == 0){
            self.APPOINTMENT_VIEW_MODE = false;
        }
        else{
            self.toggleStepsView(self.STEP_NUMBER);
        }
    }

    backPage() {
        const self = this;

        self.selectedPage--;
        self.offset = self.offset - self.limit;
        self.getKeyHandoverAppointments(self.searchFilter);
    }

    nextPage() {
        const self = this;

        self.selectedPage++;
        self.offset = self.offset + self.limit;
        self.getKeyHandoverAppointments(self.searchFilter);
    }

    gotoPage(pageNum){
        const self = this;

        self.offset = parseInt(pageNum) * self.limit;
        self.getKeyHandoverAppointments(self.searchFilter);
    }

    formatDate3(date){
        const self = this;

        return moment(date).format('dddd, Do MMMM YYYY');
    }

    uploadBuyerDocument(files, buyer, index){
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = "pdf";
        } else if (file.type.indexOf("image") !== -1) {
            format_type = "image";
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        // // Show 'image' preview
        // if(format_type == 'image'){
        //     var reader = new FileReader();
        //     reader.onload = function(event) {
        //         buyer['show_'+ file_type] = event.target.result;
        //     }
        //     // when the file is read it triggers the onload event above.
        //     reader.readAsDataURL(file);
        // }
        // else{
        //     buyer['show_'+ file_type] = '/images/pdf-placeholder.png';
        // }

        let policyUrl = 'sec/developer/key-handover/appointments/s3-policy-document?property_id='+self.property.id;

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(!buyer.buyer_documents){
                buyer.buyer_documents = [];
                buyer.buyer_documents[index] = {};
            }

            buyer.buyer_documents[index].file_uri = response.config.data.key;
            buyer.buyer_documents[index].name = file.name.split('.')[0];
        });
    }

    updateNiceSelect(){
        setTimeout(function () {
            $("select").niceSelect('update');
        });
    }

    isValidBuyerInput(){
        const self = this;

        let isValid = true;
        self.editBuyerErrors = {};

        $.each(self.appointmentParams.buyers, function(i, buyer){
            self.editBuyerErrors[i] = {};
            self.editBuyerErrors[i]['authorised_representative'] = {};
            if(!buyer.legal_name){
                isValid = false;
                self.editBuyerErrors[i].legal_name = "Legal name is required.";
            }
            if(!buyer.email_contact){
                isValid = false;
                self.editBuyerErrors[i].email_contact = "Email address is required.";
            }
            if(!buyer.phone_contact){
                isValid = false;
                self.editBuyerErrors[i].phone_contact = "Phone number is required.";
            }
            let isNRICRequiredForBuyer = self.key_handover_settings.value.nric_passport_buyer_required;
            let isNRICRequiredForAuthorizedPerson = self.key_handover_settings.value.nric_passport_authroised_officer_required;
            if(isNRICRequiredForBuyer && !buyer.identity_no){
                isValid = false;
                self.editBuyerErrors[i].identity_no = (buyer.identity_type === self.IDENTITY_TYPE_FOREIGNER ? 'Passport number' : 'NRIC number') + " is required.";
            }
            if(isNRICRequiredForBuyer && !buyer.identity_type){
                isValid = false;
                self.editBuyerErrors[i].identity_type = "Identity type is required.";
            }

            if(buyer.authorised_representative && !buyer.authorised_representative.legal_name){
                isValid = false;
                self.editBuyerErrors[i].authorised_representative.legal_name = "Legal name is required.";
            }
            if(buyer.authorised_representative && !buyer.authorised_representative.email_contact){
                isValid = false;
                self.editBuyerErrors[i].authorised_representative.email_contact = "Email address is required.";
            }
            if(buyer.authorised_representative && !buyer.authorised_representative.phone_contact){
                isValid = false;
                self.editBuyerErrors[i].authorised_representative.phone_contact = "Phone number is required.";
            }
            if(buyer.authorised_representative &&  !buyer.authorised_representative.identity_no && isNRICRequiredForAuthorizedPerson){
                isValid = false;
                self.editBuyerErrors[i]['authorised_representative']['identity_no']  = (buyer.authorised_representative.identity_type === self.IDENTITY_TYPE_FOREIGNER ? 'Passport number' : 'NRIC number') + " is required.";
            }
            if(buyer.authorised_representative &&  !buyer.authorised_representative.identity_type && isNRICRequiredForAuthorizedPerson){
                isValid = false;
                self.editBuyerErrors[i]['authorised_representative']['identity_type']  = "Identity type is required.";
            }

        });

        return isValid;
    }

    getBuyerName(buyer_id, buyers){
        const self = this;

        let name = '--';

        let _buyers = (buyers && buyers.length > 0)? buyers : self.buyers;

        if(!buyer_id || !_buyers){
            return name;
        }

        let buyer = _buyers.find(x => x.id == buyer_id);

        if(buyer && (buyer.legal_name)){
            name = buyer.legal_name;
        }

        return name;
    }

    getUserName(user_id){
        const self = this;

        let userName = '--';

        if(!user_id || !self.users){
            return userName;
        }

        let user = self.users.find(x => x.id == user_id);
        if(user){
            userName = self.getUserFullName(user);
        }

        return userName;
    }

    removeUser(user_id, user_type){
        const self = this;

        if(!user_id || !user_type){
            return;
        }

        if(user_type == 'buyer'){
            self.appointmentParams.buyers = $.grep(self.appointmentParams.buyers, function(obj){
                return user_id != obj.id;
            });
            self.selectedBuyer = self.appointmentParams.buyers.length? self.appointmentParams.buyers[0] : null;
        }
    }

    getStatus(status_id){
        const self = this;

        if(!status_id){
            return {name: '--', _class: ''};
        }

        let status = self.statuses.find(x => x.id == status_id);
        if(status){
            return status;
        }

        return {name: '--', _class: ''};
    }

    initStatuses(){
        const self = this;

        self.statuses = [
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED, name: 'SCHEDULED', _class: 'text-primary'},
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_PENDING, name: 'PENDING', _class: 'text-primary'},
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_SUCCESSFUL, name: 'KEY COLLECTED', _class: 'text-success'},
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED, name: 'CANCELLED', _class: 'text-warning'},
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED, name: 'EXPIRED', _class: 'text-danger'}
        ];
    }

    getParamsDate(date){
        const self = this;

        try{
            if(date != '' && date != null) {
                // Split date and time on the basis of white-space
                var date_time = date.split(" ");

                var date = date_time[0];
                var time = '';

                if(date_time.length > 1){
                    time = date_time[1];
                    // Server accepts time as 'hh:mm:ss' but jQuery timepicker is 'hh:mm'
                    if(time.split(':').length == 2){
                        time = time + ':00';
                    }
                }

                if(date.includes("-")){
                    var date_format = date + ' ' + time;
                }
                else{
                    var res = date.split("/", 3);
                    var date_format = res[2] + '-' + res[1] + '-' + res[0] + ' ' + time;
                }

                if(date_format) {
                    /** WEB-4818: the date and time are the project's wall clock, not the browser's */
                    var utcFormat = self.SSKeyHandoverScheduleService.projectToUtcDateTime(
                        date_format.trim() + (time? '' : ' 00:00:00'), self.timeZoneId);
                }

                return utcFormat;
            }
            else{
                return null;
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    formatUtcToLocalDate(date){
        const self = this;

        var local = date;

        try{
            if(typeof date === 'string'){
                /** WEB-4818: UTC → the project's wall clock, as the slots are shown */
                local = self.SSKeyHandoverScheduleService.utcToProjectMoment(date, self.timeZoneId);
            }
        }
        catch(ex){
            console.log(ex);
        }

        return local;
    }

    updateFilter() {
        const self = this;

        self.offset = 0;
        self.page = 1;
        self.getKeyHandoverAppointments(self.searchFilter, self.page);
    }

    openDocumentUploadPopup(){
        const self = this;
        self.upload_doc_obj = {};
        self.upload_doc_error = {};
        $('#uploadDocumentKeyHandoverModal').modal('show');
    }

    userSelectkeyHandOverDocument(file){
        const self = this;

        self.upload_doc_error.document = "";

        if (!file ) return;

        if (file.type.indexOf("application/pdf") !== -1) {
            self.upload_doc_obj.format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else {
            self.upload_doc_error.document = "Please upload PDF file only";
            return;
        }

        // Create a FileReader object
        const reader = new FileReader();

        // Set up the reader's onload event handler
        reader.onload = function(e) {
            // Get the image data URL
            self.upload_doc_obj.selected_file_url = e.target.result;
            // self.upload_doc_obj.selected_file_url_base64 = e.target.result.split(',')[1];

        };

        // Read the selected file as Data URL
        reader.readAsDataURL(file);

        self.upload_doc_obj.selected_file = file
        self.upload_doc_obj.name = file.name;
    }

    openDocumentForView(){
        const self = this;
        const newTab = window.open();
        newTab.document.write(
            `<iframe src="${self.upload_doc_obj.selected_file_url}" frameborder="0" style="border:0; top:0; left:0; bottom:0; right:0; width:100%; height:100%;" allowfullscreen></iframe>`
        );
        // window.open( self.upload_doc_obj.selected_file_url, '_blank');
    }

    isValidDocumentInput(){
        const self = this;

        let isValid = true;

        if(!self.upload_doc_obj.name){
            self.upload_doc_error.name = "Document name field is required";
            isValid = false;
        }
        if(!self.upload_doc_obj.selected_file){
            self.upload_doc_error.document = "Please select PDF file";
            isValid = false;
        }
        return isValid;
    }

    uploadDocument() {
        const self = this;
        self.upload_doc_error = {};
        if(!self.isValidDocumentInput()){
            return;
        }
        let file = self.upload_doc_obj.selected_file;

        let policyUrl = 'sec/developer/key-handover/appointments/s3-policy-document?property_id='+self.property.id;

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.upload_doc_obj.file_uri = response.config.data.key;
            self.createDocumentWithFileURI();
        });
    }



    createDocumentWithFileURI() {
        const self = this;
        let url = 'sec/developer/key-handover/appointments/'+ self.appointmentParams.id+ '/document';
        let params = {
            name: self.upload_doc_obj.name,
            type: self.APPOINTMENT_FILE_TYPE_OTHERS,
            file_uri: self.upload_doc_obj.file_uri,
            is_user_uploaded: 1
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            $('#uploadDocumentKeyHandoverModal').modal('hide');
            self.appointmentParams.documents.push(response.data.document);
            self.SSAlertService.success('Success!', 'File uploaded successfully.');

        });
    }

    getAppointmentDocuments(){
        const self = this;
        let url = 'sec/developer/key-handover/appointments/'+ self.appointmentParams.id+ '/documents';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.appointmentParams.documents = response.data.documents;
            self.SSAlertService.success('Success!', 'File uploaded successfully.');
        });
    }

    removeAppointmentDocument(document_id){
        const self = this;
        let url = 'sec/developer/key-handover/appointments/'+ self.appointmentParams.id+ '/document/'+document_id;
        loading(true);
        self.SSHttpService.deleteAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            let index = self.appointmentParams.documents.findIndex((element) => {return element.id === document_id;});
            self.appointmentParams.documents.splice(index, 1);
            self.SSAlertService.success('Success!', 'File remove successfully.');
        });
    }
}

SSKeyHandoverService.$inject = ['$timeout', 'SSConfigService', 'SSHttpService', 'SSAwsService', 'SSUtilService', 'SSUserService', 'SSAlertService', 'SSConfirmationService', 'SSDateService', 'SSKeyHandoverScheduleService'];
app.service('SSKeyHandoverService', SSKeyHandoverService);

/**
 * The app-wide `datepicker` directive (jQuery UI datepicker, `dd/mm/yy`).
 *
 * @remarks
 * WEB-4414: this is the ONE registration of `datepicker` for every page — services.js is loaded
 * by layouts/includes/angular-include.blade.php everywhere, and AngularJS keeps every directive
 * registration, so a page bundle that registers its own copy links the directive twice per
 * element. Pages with no copy of their own (customer EOI / Launch Day particulars, Public
 * Holidays) depend on this one. Keep it `dd/mm/yy`: Key Handover and most date consumers read
 * the value back as `DD/MM/YYYY` (WEB-4411). A page that needs different options (maxDate,
 * changeMonth, datetimepicker...) still registers its own copy — post-link runs in reverse
 * registration order, so the page copy initialises the field and this one is a no-op re-init;
 * such copies must be listed in CROSS_BUNDLE_ALLOWED in
 * tests/standalone/bundle_duplicate_registrations_test.js.
 */
app.directive("datepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "datepicker()" METHOD USING THE "element" OBJECT.
        element.datepicker({
            //inline: true,
            dateFormat: "dd/mm/yy"
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});

// app.directive('dateformat', function (dateFilter) {
//     return {
//         require:'ngModel',
//         link:function (scope, elm, attrs, ctrl) {

//             var dateFormat = attrs['date'] || 'dd/MM/yyyy';

//             ctrl.$formatters.unshift(function (modelValue) {
//                 return dateFilter(modelValue, dateFormat);
//             });
//         }
//     };
// })
